<template>
  <div class="package-table" :style="{ marginTop: presetKitId ? '25px' : '5px' }">
    <div class="package-table__actions">
      <CustomButton v-if="!this.hideSubmitBtn" :disabled="this.loading || btnLoading || !!this.disableSubmit"
        :loading="this.loading || btnLoading" type="submit" @click="this.handleClickDocUpload" style="width: auto;">
        {{ 'Загрузить документ' }}
      </CustomButton>
    </div>

    <q-linear-progress v-if="isFetching" indeterminate />
    <CustomTable :rowsData="data" :customHeader="true" :custom-body="true" :small="true">
      <template #customHeader="">
        <q-tr>
          <q-th align="center"> # </q-th>
          <q-th align="left" style="font-weight: 700;">
            Наименование документа
          </q-th>
          <q-th align="center" style="font-weight: 700;">
            Тип документа
          </q-th>
          <q-th align="center" style="font-weight: 700;">
            Статус подписания
          </q-th>
          <q-th align="center" style="font-weight: 700;">
            Дата создания
          </q-th>
          <q-th align="center" style="font-weight: 700;">
            Действие
          </q-th>
          <q-th align="center" style="font-weight: 700;"></q-th>
          <q-th align="center" style="font-weight: 700;"></q-th>
        </q-tr>
      </template>
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.project_document_id }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.project_document_name }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.project_document_type_name }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div class="signers-list">
              <div v-if="props.row.signers && props.row.signers.length > 0"
                style="display: flex; flex-direction: column; gap: 4px;">
                <div v-for="signer in props.row.signers" :key="signer.project_document_sign_id" class="signer-item">
                  <div class="signer-info">
                    <span class="signer-name">{{ signer.dn_fio }}</span>
                    <span class="signer-role">{{ signer.assign_type_name }}</span>
                  </div>
                  <div v-if="signer.is_signed" class="signature-badge signed">
                    <q-icon name="check_circle" size="12px" />
                    <span>{{ signer.sign_date }}</span>
                  </div>
                  <div v-else class="signature-badge pending">
                    <q-icon name="schedule" size="12px" />
                    <span>не подписан</span>
                  </div>
                </div>
              </div>
              <span v-else class="no-signers">—</span>
            </div>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.rowversion }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <CustomDropdown :loading="infoLoading[props.row.project_id]"
              @click="action => this.handleAction(props.row, action.action)"
              :options="this.getActionsDropdown(props.row)" title="Действие" />
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <Clickable @click="() => downloadDoc(props.row.project_document_id, props.row.project_document_name)"
              :disabled="downloading[props.row.project_document_id]">
              <ShinyButton v-if="downloading[props.row.project_document_id]" text="Скачать" />
              <span v-else>Скачать</span>
              <q-icon name="download" />
            </Clickable>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <CustomIcon icon="trash" :approve-mode="true" :small="true"
              :loading="infoLoading[props.row.project_document_id]"
              :approve="() => deleteDocument(props.row.project_document_id)" />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from '@/components/common/CustomTable';
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell';
import CustomSelect from '@/components/form/CustomSelect';
import CustomButton from '@/components/common/CustomButton';
import { MODAL_NAMES } from '@/constants';
import { useAppStore } from "@/services/store/app"
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { getProjectDocs, addProjectDocument, signDocuments, downloadProjectDocumentPDF, deleteDocument } from './services';
import Clickable from '@/components/common/Clickable';
import ShinyButton from '@/components/common/ShinyButton';
import CustomDropdown from '@/components/common/CustomDropdown';
import CustomIcon from '@/components/common/CustomIcon';

export default {
  name: 'ProjectDocs',
  props: {
    projectId: {
      type: Number,
    },
  },
  components: {
    CustomTable,
    CustomTableCell,
    CustomSelect,
    CustomButton,
    Clickable,
    ShinyButton,
    CustomDropdown,
    CustomIcon,
  },
  data() {
    return {
      isFetching: false,
      data: null,
      downloading: {},
      infoLoading: {},
    }
  },
  computed: {
    params() {
      return {
        project_id: this.projectId,
      }
    },
  },
  methods: {
    getActionsDropdown() {
      return [
        { label: 'Подписать документ', action: 'signDoc' },
      ]
    },
    async handleAction(row, action) {
      const body = {
        project_document_id: row.project_document_id,
      }
      if (action === 'signDoc') {
        this.infoLoading[row.project_id] = true;
        const res = await signDocuments(body)
        this.infoLoading[row.project_id] = false;
        if (!res) return
        const signUrl = res?.redirect_url
        window.open(signUrl, '_blank');
        this.getData()
        this.showSucceedSnackbar()
      }
    },
    async getData() {
      this.isFetching = true
      const res = await getProjectDocs(this.params)
      this.isFetching = false
      this.data = res || []
    },
    handleClickDocUpload() {
      this.showModal(MODAL_NAMES.AddDocumentEntry, {
        title: 'Загрузить документ',
        onSubmit: this.onAddSubmit,
      })
    },
    async downloadDoc(project_document_id, fileName) {
      this.downloading[project_document_id] = true;
      await downloadProjectDocumentPDF(project_document_id, fileName)
      this.downloading[project_document_id] = false;
    },
    async onAddSubmit(body) {
      const res = await addProjectDocument(body, this.projectId)
      if (!res) return
      this.data = res || []
      this.showSucceedSnackbar()
      this.closeModal()
    },
    async deleteDocument(project_document_id) {
      this.infoLoading[project_document_id] = true;
      const res = await deleteDocument(project_document_id, this.params)
      this.infoLoading[project_document_id] = false;
      if (!res) return
      this.data = res || []
      this.showSucceedSnackbar()
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showModal, closeModal } = useAppStore()
    const { showSucceedSnackbar } = useCustomSnackbar()
    return { showModal, closeModal, showSucceedSnackbar }
  },
}
</script>

<style lang="scss" scoped>
.package-table {
  margin-top: 25px;

  .table-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .row {
      margin-right: 16px;
    }
  }

  .createBtn {
    width: auto;
    font-weight: 400;
    height: 44px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
}


.signers-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  min-width: 250px;
}

.signer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  gap: 8px;
  transition: all 0.15s ease;

  &:hover {
    background: #f0f2f5;
    border-color: #d0d0d0;
  }
}

.signer-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.signer-name {
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.signer-role {
  font-size: 9px;
  font-weight: 500;
  color: #7f8c8d;
  text-align: left;
}

.signature-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;

  &.signed {
    background: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;

    .q-icon {
      color: #4caf50;
    }
  }

  &.pending {
    background: #fff3e0;
    color: #f57c00;
    border: 1px solid #ffcc80;

    .q-icon {
      color: #ff9800;
    }
  }

  span {
    font-size: 10px;
  }
}

.no-signers {
  color: #95a5a6;
  font-size: 14px;
  text-align: center;
}
</style>
